import { PlaceholderSkeleton } from '../../PlaceholderSkeleton';
import { Value } from './value';

export const PayoutValue = ({ value, loading, ...rest }: { value: string | undefined; loading: boolean }) => (
  <PlaceholderSkeleton loading={loading} height='1.7em' margin='0.5em 0 0 0'>
    <Value {...rest}>{value}</Value>
  </PlaceholderSkeleton>
);
